import actions from './actions';

const { 
    RANKING_DATA_DATA_BEGIN, RANKING_DATA_DATA_SUCCESS, RANKING_DATA_DATA_ERR,
} = actions;

const initialStateArray = { data: [], loading: false, error: null, };

// QR Payment Information Data Reducers
export const getStoreRankingDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case RANKING_DATA_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case RANKING_DATA_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case RANKING_DATA_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };

        default:
            return state;
    }
};